module.exports = __webpack_public_path__ + "static/media/img_payment_complete.445210a0.png";